var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClasses,on:{"click":_vm.toggleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }